import Vue from 'vue';
import VueRouter from 'vue-router';
import App from '../App.vue';

Vue.use(VueRouter);

const routes = [
  // Data to fetch: Industries
  {
    path: '/',
    name: 'home',
    component: App,
  },
  // Data to fetch: none
  {
    path: '/search',
    name: 'search',
    component: App,
  },
  // Data to fetch: 
  // If category is null: Industries
  // If using filter: Retrieve the list of Industries 
  // If reload (pasting the full url)
  //    Step 1: CategoryID is used to retrieve DivisionID and IndustryID (getDivisionAndIndustry endpoint)
  //    Step 2:
  //              1- Retrieve the list of Industries
  //              2- IndustryID is used to retrieve the list of Divisions - Depends ON Step 1
  //              3- DivisionID is used to retrieve the list of Classes - Depends ON Step 1
  //              4- CategoryID is used to retrieve Bic list
  {
    path: '/browse/class/:category?',
    name: 'browsing', // browse doesn't work (??!!)
    component: App,
  },
  // Required parameter: division
  // Data to fetch: 
  //    Step 1: DivisionID is used to retrieve the Division details and IndustryID (/divisions/<DivisionID>) 
  //    Step 2:
  //              1- Retrieve the list of Industries
  //              2- DivisionID is used to retrieve the list of Classes (/divisions/<DivisionID>/classes/) 
  //              3- IndustryID is used to retrieve the list of Divisions (/industries/<IndustryID>/divisions) - Depends ON Step 1
  {
    path: '/browse/division/:division',
    name: 'division',
    component: App,
  },
  // Required parameter: industry
  // Data to fetch: 
  //                1- Retrieve the list of Industries
  //                2- IndustryID is used to retrieve the list of Divisions (/industries/<IndustryID>/divisions?filter[order]=name)
  {
    path: '/browse/industry/:industry',
    name: 'industry',
    component: App,
  },
  // Required data: Bics
  {
    path: '/selected',
    name: 'selected',
    component: App,
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;